import request from "@/utils/request";

enum Method {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

/**
 * 创建新的锦礼活动
 * @param activity
 * @returns
 */
export function addActivity(activity: ActivityJinli) {
  return request({
    url: "/admin/activity/jinli",
    method: Method.POST,
    data: activity,
    headers: {
      "Content-Type": "application/json",
    },
    needToken: true,
  });
}

/**
 * 更新活动的配置信息
 * @param id 活动ID (路径参数)
 * @param accessKey 访问密钥
 * @param rsaPublicKey RSA公钥
 * @param rsaPrivateKey RSA私钥
 * @returns
 */
export function updateActivityConfiguration(
  id: number,
  accessKey: string,
  rsaPublicKey: string,
  rsaPrivateKey: string
) {
  return request({
    url: `/admin/activity/jinli/${id}/configuration`,
    method: Method.PUT,
    params: {
      accessKey,
      rsaPublicKey,
      rsaPrivateKey,
    },
    needToken: true,
  });
}

/**
 * 停用指定的活动
 * @param id 活动ID (路径参数)
 * @returns
 */
export function disableActivity(id: number) {
  return request({
    url: `/admin/activity/jinli/${id}/disable`,
    method: Method.PUT,
    needToken: true,
  });
}

/**
 * 更新活动的详细信息
 *@param activityId  活动ID (路径参数)
 *@param activity 活动信息对象
 * */
export function updateActivity(activityId: string, activity: ActivityJinli) {
  return request({
    url: `/admin/activity/jinli/${activityId}`,
    method: Method.PUT,
    data: activity,
    headers: {
      "Content-Type": "application/json",
    },
    needToken: true,
  });
}

/**
 * 删除指定的活动
 * @param activityId 活动ID (路径参数)
 * @returns
 */
export function deleteActivity(activityId: number) {
  return request({
    url: `/admin/activity/jinli/${activityId}`,
    method: Method.DELETE,
    needToken: true,
  });
}

/**
 * 分页查询活动列表
 * @param params 查询参数
 * @returns
 */
export function listActivities(params: ListActivitiesParams) {
  return request({
    url: "/admin/activity/jinli",
    method: Method.GET,
    params,
    needToken: true,
  });
}
export interface ListActivitiesParams {
  pageNo: number;
  pageSize: number;
  isConfigured?: string;
  activityStatus?: string;
  activityName?: string;
  activityScene?: string;
  activityId?: string;
  activityRemark?: string;
  activityLink?: string;
  activityShortCode?: string;
  activityStartTime?: string;
  activityEndTime?: string;
}

/**
 * 根据活动短码查询活动信息
 * @param shortCode 活动短码
 * @returns
 */
export function getActivityByShortCode(shortCode: string) {
  return request({
    url: `/admin/activity/jinli/code/${shortCode}`,
    method: Method.GET,
    needToken: true,
  });
}

/**
 * 根据活动ID查询活动信息
 * @param activityId 活动ID (路径参数)
 * @returns
 */
export function getActivityById(activityId: number) {
  return request({
    url: `/admin/activity/jinli/${activityId}`,
    method: Method.GET,
    needToken: true,
  });
}
/**
 * 获取加价规则
 *
 */
export function getAddPriceRules() {
  return request({
    url: `/admin/jinli/price-rule/batch`,
    method: Method.GET,
    needToken: true,
  });
}
/**
 * 查询已挑选的活动
 */
export function getSelectedActivity(shop_id: number) {
  return request({
    url: `/admin/jinli/price-rule/list`,
    method: Method.GET,
    needToken: true,
    params: { shop_id },
  });
}

/**
 * 批量保存锦礼活动店铺加价规则
 */
export function saveAddPriceRules(data: any) {
  return request({
    url: `/admin/jinli/price-rule/batchSave`,
    method: Method.POST,
    headers: {
      "Content-Type": "application/json",
    },
    needToken: true,
    data,
  });
}

// 活动状态枚举
export enum ActivityStatus {
  /** 已结束 */
  NOT_STARTED = "NOT_STARTED",
  /** 已开始 */
  IN_PROGRESS = "IN_PROGRESS",
  /** 已结束 */
  DISABLED = "DISABLED",
  /** 已过期 */
  EXPIRED = "EXPIRED",
}

// 配置状态枚举
export enum ConfigurationStatus {
  /** 已配置 */
  CONFIGURED = "CONFIGURED",
  /** 未配置 */
  UNCONFIGURED = "UNCONFIGURED",
}

// 锦礼活动实体接口
export interface ActivityJinli {
  /** 主键ID */
  id?: number;
  /** 活动编号 */
  activity_number?: string;
  /** 活动名称 */
  activity_name: string;
  /** 活动开始时间 */
  activity_start_time: string;
  /** 活动结束时间 */
  activity_end_time: string;
  /** 活动场景 */
  activity_scene: string;
  /** 活动状态 */
  activity_status?: ActivityStatus;
  /** 是否已配置 */
  is_configured?: ConfigurationStatus;
  /** 活动价格倍率(0-10之间，精确到小数点后2位) */
  activity_price_rate: number;
  /** 活动链接 */
  activity_link?: string;
  /** 活动备注 */
  activity_remark?: string;
  /** 活动短码 */
  activity_short_code?: string;
  /** 访问密钥 */
  access_key?: string;
  /** RSA公钥 */
  rsa_public_key?: string;
  /** RSA私钥 */
  rsa_private_key?: string;
  /** 创建时间 */
  create_time?: string;
  /** 最后更新时间 */
  last_update_time?: string;
  /** 创建人 */
  creator?: string;
  /** 最后更新人 */
  last_updater?: string;
}

// 分页响应接口
export interface PageResponse<T> {
  /** 当前页码 */
  pageNo: number;
  /** 每页数量 */
  pageSize: number;
  /** 总记录数 */
  total: number;
  /** 数据列表 */
  data: T[];
}
